import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const TurksandCaicosIslands: Country = {
    identifier: "TurksandCaicosIslands",
    name: "Turks and Caicos Islands",
    countryCode: "TC",
    group: CountryGroup.NORTH_AMERICA,
    isUNMember: false,
    flag: "🇹🇨",
    svgPath: "m 273.16475,400.4864 -0.049,0.032 -0.163,-0.104 -0.023,-0.083 -0.058,-0.004 -0.097,-0.075 0.023,-0.097 0.222,-0.004 0.089,0.269 0.056,0.066 z m 0.614,0.226 -0.011,0.041 -0.159,-0.116 -0.305,-0.001 -0.048,-0.159 0.117,-0.026 0.387,0.056 0.088,0.138 -0.069,0.067 z m -1.885,-0.258 0.321,0.166 0.193,-0.025 0.016,0.036 -0.104,0.038 -0.026,0.031 -0.309,0.043 -0.097,-0.008 -0.02,-0.112 0.026,-0.169 z",
}
